<h3 mat-dialog-title>{{ 'FRONTEND.SALES_UI.PIPELINE.PREPARING_CSV' | translate }}</h3>
<mat-dialog-content>
  <div class="icon-div">
    <mat-icon class="icon">circle_notifications</mat-icon>
  </div>
  <p>{{ 'FRONTEND.SALES_UI.PIPELINE.PREPARING_DOWNLOAD' | translate }}</p>
  <p>{{ 'FRONTEND.SALES_UI.PIPELINE.OK_TO_LEAVE_PAGE' | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button color="primary" data-action="clicked-OK-on-pipeline-export-csv-modal" mat-dialog-close mat-flat-button>
    {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.OK' | translate }}
  </button>
</mat-dialog-actions>
